import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/merchant_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  introduction_cont: {
    model_name: 'Merchant',
    column_type: 'string',
    column_name: 'introduction',
  },
  name_cont: {
    model_name: 'Merchant',
    column_type: 'string',
    column_name: 'name',
  },
  store_owner_id_eq: {
    column_type: 'belongs_to',
    column_name: 'store_owner',
    extra: {
      model_name: 'StoreOwner',
    },
    model_name: 'Merchant',
  },
  store_owner: {
    column_type: 'belongs_to',
    column_name: 'store_owner',
    extra: {
      model_name: 'StoreOwner',
    },
    model_name: 'Merchant',
  },
  show_on_places_section_eq: {
    column_type: 'boolean',
    model_name: 'Merchant',
    column_name: 'showOnPlacesSection',
  },
  show_on_catalog_eq: {
    column_type: 'boolean',
    model_name: 'Merchant',
    column_name: 'showOnCatalog',
  },
  show_on_explore_section_eq: {
    column_type: 'boolean',
    model_name: 'Merchant',
    column_name: 'showOnExploreSection',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'store_owner_id': { required: true, disabledUpdate: false },
    'whatsapp': { required: true, disabledUpdate: false },
    'phone': { required: false, disabledUpdate: false },
    'instagram': { required: false, disabledUpdate: false },
    'gozem': { required: false, disabledUpdate: false },
    'logo': { required: false, disabledUpdate: false },
    'cover': { required: false, disabledUpdate: false },
    'location': { required: false, disabledUpdate: false },
    'latitude': { required: false, disabledUpdate: false },
    'longitude': { required: false, disabledUpdate: false },
    'introduction': { required: false, disabledUpdate: false },
    'images': { required: false, disabledUpdate: false },
    'show_on_places_section': { required: false, disabledUpdate: false },
    'show_on_catalog': { required: false, disabledUpdate: false },
    'show_on_explore_section': { required: false, disabledUpdate: false },
    'position': { required: false, disabledUpdate: false },
    'tag_list': { required: false, disabledUpdate: false },
    'explore_tag_list': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Merchant', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Merchant', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
